export const config = {
  backendHost: process.env.REACT_APP_BACKEND_HOST || 'http://localhost:8001'
};
